import { render, staticRenderFns } from "./Institution.vue?vue&type=template&id=22e53d52&"
import script from "./Institution.vue?vue&type=script&lang=js&"
export * from "./Institution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports